/**
 * Zkontroluje, zda je objekt prázdný
 * @param value - Objekt k ověření
 * @returns true pokud je objekt prázdný, jinak false
 */
export function objectEmptyCheck(value: Record<string, unknown>): boolean {
  return Object.keys(value).length === 0 && value.constructor === Object;
}
